module.exports = __webpack_public_path__ + "static/img/i44.f01512a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/i44.png
// module id = B18j
// module chunks = 3